<div class="user-profile-container">

  <a href="jaavscript:void(0)" [routerLink]="cartUrl" [queryParams]="queryParams" mat-flat-button class="header-cart"
    *ngIf="!cartLoader && cartCounter>0 && (roleCheckService.isCompanyOwner() || roleCheckService.isSuperAdmin() || roleCheckService.isCompanyAdmin())">
    <span class="material-symbols-outlined">shopping_cart</span>
    <span class="counter">{{cartCounter}}</span>
  </a>

  <button class="di-user-dropdown" [matMenuTriggerFor]="menu">
    <!-- <div class="top-avatar img" *ngIf="!roleCheckService.isSuperAdmin(); else sadmin">
      <app-profile-img [type]="'profile'"></app-profile-img>
      <span *ngIf="innerWidth >= 1200">{{jwtService.getUserName()}}</span>
    </div>
    <ng-template #sadmin>
      <div class="top-avatar img">
        <app-profile-img [type]="'profile'"></app-profile-img>
        <span *ngIf="innerWidth >= 1200">{{jwtService.getUserName()}}</span>
      </div>
    </ng-template> -->
    {{nameAbbr}}
  </button>
  <mat-menu #menu="matMenu" class="user-dropdown-wrapper">
    <div (click)="$event.stopPropagation()" class="user-details">
      <div class="user-image">
        <app-profile-img [type]="'profile'"></app-profile-img>
      </div>
      <div class="user-name">
        <h3>{{jwtService.getUserName()}}</h3>
        <div>{{jwtService.getUserEmail()}}</div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <button mat-menu-item [routerLink]="['/my-account/']">
      <span class="material-symbols-outlined">edit</span>
      <span>Edit Profile</span>
    </button>

    <!-- <button mat-menu-item [routerLink]="['/my-account/']">
     <span class="material-symbols-outlined">lock</span>
      <span>Change Password</span>
    </button> -->

    <button mat-menu-item (click)="logout()">
      <span class="material-symbols-outlined">logout</span>
      <span>Log out</span>
    </button>

  </mat-menu>
</div>